import checkDuplicateButtonStatus from "web/utils/page/product/subscription/checkDuplicateButtonStatus";

const addDuplicateOrderStatus = (currentForms, enableOrderDuplicateCard) => {
  const preparedForm = currentForms.map((ele) => {
    const { lastSportCardRequestAt } = ele;
    const duplicateOrderStatus = checkDuplicateButtonStatus(
      lastSportCardRequestAt,
      enableOrderDuplicateCard
    );
    return { ...ele, duplicateOrderStatus };
  });

  return preparedForm;
};

export default addDuplicateOrderStatus;
